<template>
    <div class="info-popover-container d-inline-block">
      <button 
        type="button" 
        class="btn btn-link p-0 border-0 bg-transparent"
        data-bs-toggle="modal" 
        data-bs-target="#zx2zaehneModal"
        aria-label="Hinweis zu Fehlenden Zähnen"
      >
        <info_icon_blau></info_icon_blau>
      </button>
    </div>
  
    <!-- Bootstrap Modal -->
    <div class="modal fade" id="zx2zaehneModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content info-popover-modal">
          <div class="modal-header border-0 pb-2 text-start d-flex flex-row align-items-center">
            <span class="ms-2 me-3">
              <info_icon_blau></info_icon_blau>
            </span>
            <div>
              <strong>Was sind fehlende Zähne?</strong>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
          </div>
         
            <div class="modal-body ps-4 pe-3 pb-3 text-start">
        <div class="mb-2"><b>Es handelt sich um Zähne, die vor Vertragsabschluss fehlen und nicht ersetzt worden sind.</b></div>
        <div class="mb-2">Dazu zählen nicht: Weisheitszähne, Milchzähne und Lückenschluss<sup>*</sup>.
          Bei gesetzten Kronen, Brücken und Prothesen gelten Zähne als ersetzt.
        </div>
        <div class="mb-2">* Physiologischer Lückenschluss = Zahnlücke, die bereits durch die beiden Nachbarzähne geschlossen worden ist.
        </div>
        <div>Bitte haben Sie Verständnis dafür, dass wir Ihnen bei mehr als zwei fehlenden Zähnen keinen Versicherungsschutz im Tarif Zahnersatz x2 anbieten können.
        </div>
      </div>
          </div>
        </div>
      </div>
    
  </template>
  
  <script setup>
  import info_icon_blau from '@/components/icons/info_icon_blau.vue';
  </script>
  
  <style scoped>
  .info-popover-container {
      margin-left: 10px;
      position: relative;
      top: -3px;
  }
  
  .info-popover-modal {
      border: none;
      background: linear-gradient(to right, var(--vigo-1-500-bg) 0%, var(--vigo-1-500-bg) 7px, var(--vigo-5-100-bg) 7px, var(--vigo-5-100-bg) 100%);
      border-radius: var(--vigo-border-radius-md);
      font: var(--vigo-font-base);
      max-width: 600px;
  }
  
  .btn-link {
      text-decoration: none;
  }
  
  .btn-link:hover {
      text-decoration: none;
  }
  </style>
  